import React from 'react';
import './About.css';

const About = ({ t }) => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img src={`${process.env.PUBLIC_URL}/images/20240504_095704.jpg`} alt="Senegal" />
            <div className="about-badge">
              <span className="years">{t.badge.years}</span>
              <span className="text">{t.badge.text}</span>
            </div>
          </div>
          <div className="about-text">
            <span className="section-tag">{t.tag}</span>
            <h2>{t.title}</h2>
            <p>{t.text1}</p>
            <p>{t.text2}</p>
            <a href="#tours" className="btn-primary">{t.button}</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
